import { Observable } from 'rxjs';
import { CrudDataSource, Role, RoleService, PageSpecification, HateoasMultipleResponseObject } from '@scisys-uim/uim-common';


export class RolesDataSource extends CrudDataSource<Role> {


  constructor(private roleService: RoleService) {
    super();
  }

  protected callLoaderService(serviceArguments: any, pageSpec: PageSpecification): Observable<HateoasMultipleResponseObject<Role>> {
    return this.roleService.findRolesByName(serviceArguments.nameFilter, pageSpec);
  }


}
